import React, { useState, useEffect, Fragment } from 'react';
import VouchersForm from './VouchersForm';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
  postAPI_Create_Vouchers,
  API_StandAlonePage_Connection,
  postAPI_Create_A_Message,
  putAPI_Update_Vouchers, gAPI_Vouchers_By_Id
} from '../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
  Button, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown
} from 'reactstrap';
import BuyOption from './BuyoptionForm';
import InviteVoucher from './InviteVoucher';
import Validation from '../../../../../../../components/Validation';
import SellVoucher from './SellVoucher';
import short from 'short-uuid';
import Axios from 'axios';
import { reactSelectOptionDiffrentPro } from '../../../../../../../helpers/Utils';
import GenerateCodes from './GenerateCodes';
import GiftCardForm from './giftCardForm';
import AdsForm from './AdsForm';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;
function CreateVouchersForm({ propertyId, LoadData, memberShipTags, email, isCustomCode, reportingTagData, websiteIntregation, amadeus, xolaIntegration, ShowInviteVoucher, handlePreviewVoucher, inviteVoucher, voucherName, propertydata, userData, voucherList, isBuyOption, locale, invitation, voucherId }) {
  const [visible, setVisible] = useState(false);
  const [buyOptionvisible, setbuyOptionVisible] = useState(false);
  const [voucher, setVoucher] = useState('');
  const [codeVisible, setCodeVisible] = useState(false);
  const [websiteIntregationId, setWebsiteIntregationId] = useState('');
  const [sellVoucher, setSellVoucher] = useState(false);
  const [showInvitations, setShowInvitations] = useState(false);
  const [giftCard, setGiftCard] = useState(false);
  const [adsFrom, setAdsForm] = useState();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties: [propertyId],
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',
    IsFooterHide: false,
    PageSettings: {
      layoutType: 0, title: '', subtitle: '', scrollDirection: 1, arrowType: 0, arrowSize: 40,
      colours: {
        title: '', subtitle: '', arrow: 'black', primaryColor: '#E31B78',
        buttonColor: '#033DA5',
        redeemBar: '#FA8DAB',
        redeemButton: '#F5D2E3',
        buttonTextColor: 'white',
        redeemTextColor: 'black',
        shoppingBar: '#ED187B',
        logoLink: '',
        shoppingBarText: 'white'
      }, icon: 'https://via.placeholder.com/150/'
    }
  });
  const handleSubmit = (data) => {
    if (!buyOptionvisible) {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Vouchers}`,
        data,
      })
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            setVisible(!visible);
            setGiftCard(!giftCard);
    
            if (voucherList.length === 0 && websiteIntregation.length === 0) {
              handleSave();
            }
            LoadData();
            setVisible(!visible);
          }
        })
    } else {
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Vouchers}/${voucherId}`,
          data: data,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            LoadData();
            setbuyOptionVisible(!buyOptionvisible);
          }
        });
      }    
  };

  const handlePreview = () => {
    if (websiteIntregation.length === 1 && voucherList.length > 0) {
      var url = `${process.env.REACT_APP_VOUCHER_URL}/voucherengine?&iid=${websiteIntregation[0].id}&gid=${getGroupID()}`;
      window.open(url, '_blank');
    }
    else {
      handlePreviewVoucher(true);
    }

  };
  const handleSave = async () => {
    /**  When creating a response for a integration, don't need pass a property id*/

    AxiosAPI({
      method: 'post',
      url: API_StandAlonePage_Connection,
      data: inputData,
    });
  };
  return (
    <div className='row mb-3'>
      {!isBuyOption && !isCustomCode && <UncontrolledDropdown className="text-center  ml-3">
        <DropdownToggle caret color="outline-dark" className="outline-blue" size="xs">
          + New
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => {
            setVisible(!visible);
          }}>
            + Voucher
          </DropdownItem>
          <DropdownItem onClick={() => {
            setGiftCard(!giftCard);
          }}>
            + E-Gift Card
          </DropdownItem>
          <DropdownItem onClick={() => {
            setAdsForm(!adsFrom);
          }}>
            + Advertisement
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>}

      {!isBuyOption && !isCustomCode && <UncontrolledDropdown className="text-center  ml-3">
        <DropdownToggle caret color="outline-dark" className="outline-blue" size="xs">
          + Partner
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => {
            ShowInviteVoucher(!inviteVoucher);
          }}>
            + Invite a business to sell your vouchers
          </DropdownItem>
          <DropdownItem onClick={() => {
            setSellVoucher(!sellVoucher);
          }}>
            + Resell vouchers of a partner business
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>}

      {websiteIntregation.length === 1 && !isCustomCode && (isBuyOption === undefined || isBuyOption === false) &&
        <UncontrolledDropdown className="text-center  ml-3">
          <DropdownToggle caret color="outline-dark" className="outline-blue" size="xs">
            Preview
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              onClick={() => { handlePreview(); }}
            >
              Preview your vouchers store
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>}

      {/* {!isBuyOption && !isCustomCode && <Button
          color="primary"
          outline
          size="lg"
          onClick={() => {
            setVisible(!visible);
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Create a voucher
        </Button>} */}

      {/* {!isBuyOption && !isCustomCode && <div className='col-md-4 mb-1'>
        <Button
          color="primary"
          outline
          size="lg"
          onClick={() => {
            setGiftCard(!giftCard);
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Create a E-Gift Card
        </Button>
      </div>} */}
      {isBuyOption && !isCustomCode && <div className='col-md-12 mb-1'>
        <Button
          color="primary"
          outline
          size="lg"
          onClick={() => {
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_Vouchers_By_Id}/${voucherId}`,
            })
              .then((res) => {
                setVoucher(res.data);
                setbuyOptionVisible(!buyOptionvisible);
              })
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Add a variant
        </Button></div>}
      {/* {!isBuyOption && !isCustomCode &&  <div className='col-md-4 mb-1'>
        <Button
          color="primary"
          outline
          size="lg"
          onClick={() => {
            setAdsForm(!adsFrom);
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + New Advertisement
        </Button>
      </div>} */}

      {/* <div className='col-md-4 mb-1'>
        {!isBuyOption && !isCustomCode && <Button
          color="primary"
          outline
          size="lg"
          onClick={() => {
            
          }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          
        </Button>}
      </div>
      <div className='col-md-6 mb-1'>
        {!isBuyOption && !isCustomCode && <Button
          color="primary"
          outline
          size="lg"
          onClick={() => { setSellVoucher(!sellVoucher); }}
          style={{ width: '100%', borderRadius: '6px' }}
        >
          + Resell vouchers of a partner business
        </Button>}

      </div> */}
      {/* {websiteIntregation.length === 1 && !isCustomCode && (isBuyOption === undefined || isBuyOption === false) &&
        <div className='col-md-6 mb-1'>
          <Button
            color="primary"
            outline
            size="lg"
            onClick={() => { handlePreview(); }}
            style={{ width: '100%', borderRadius: '6px' }}
          >
            Preview your vouchers store
          </Button>
        </div>} */}
      {websiteIntregation.length >= 2 && !isCustomCode && (isBuyOption === undefined || isBuyOption === false) &&

        <UncontrolledDropdown className="text-center  ml-3">
          <DropdownToggle caret color="outline-dark" className="outline-blue" size="xs">
            Preview
          </DropdownToggle>
          <DropdownMenu>
            {websiteIntregation.map((m) =>
              <DropdownItem onClick={() => {
                setWebsiteIntregationId(m.value);
                var url = `${process.env.REACT_APP_VOUCHER_URL}/vhp?iid=${m.id}&gid=${getGroupID()}`;
                window.open(url, '_blank');
              }}>
                {m.name !== '' ? m.name : "Standalone Store"}
              </DropdownItem>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
        //   <div style={{ width: '100%', color: 'black', textAlign: 'center' }} className="col-md-6">
        //   <Select
        //     isMulti={false}
        //     className="react-select integration-button btn-outline-primary"
        //     classNamePrefix="react-select"
        //     placeholder={"Preview your vouchers store"}
        //     onChange={(m) => {
        //       setWebsiteIntregationId(m.value);
        //       var url = `${process.env.REACT_APP_VOUCHER_URL}/vhp?iid=${m.value}&gid=${getGroupID()}`;
        //       window.open(url, '_blank');              
        //     }}
        //     options={
        //       websiteIntregation && websiteIntregation.length > 0
        //         ? reactSelectOptionDiffrentPro(
        //           websiteIntregation,
        //           true,
        //           'id',
        //           'name',
        //           ''
        //         )
        //         : []
        //     }
        //   />
        // </div>
      }

      {visible && <VouchersForm
        formLabel="Create a New Voucher"
        visible={visible}
        reportingTagData={reportingTagData}
        amadeus={amadeus}
        memberShipTags={memberShipTags}
        xolaIntegration={xolaIntegration}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        inviteVoucher={inviteVoucher}
        ShowInviteVoucher={ShowInviteVoucher}
        propertyId={propertyId}
      />}

      {giftCard && <GiftCardForm
        memberShipTags={memberShipTags}
        formLabel="Create a New GiftCard"
        visible={giftCard}
        amadeus={amadeus}
        reportingTagData={reportingTagData}
        xolaIntegration={xolaIntegration}
        toggle={() => {
          setGiftCard(!giftCard);
        }}
        submit={handleSubmit}
        inviteVoucher={inviteVoucher}
        ShowInviteVoucher={ShowInviteVoucher}
        propertyId={propertyId}
      />}
      {
        buyOptionvisible && isBuyOption && !codeVisible && <BuyOption
          formLabel="Create a new voucher variant"
          visible={buyOptionvisible}
          toggle={() => {
            setbuyOptionVisible(!buyOptionvisible);
          }}
          update={false}
          LoadData={LoadData}
          amadeus={amadeus}
          xolaIntegration={xolaIntegration}
          id={voucherId}
          submit={handleSubmit}
          voucherName={voucherName}
          updateVoucherData={voucher}
          propert

          yId={propertyId}
        />
      }
      {
        inviteVoucher && !codeVisible && <InviteVoucher propertyId={propertyId}
          isvisible={inviteVoucher} locale={locale}
          userData={userData}
          propertydata={propertydata}
          voucherList={voucherList}
          email={email}
          toggle={() => ShowInviteVoucher(!inviteVoucher)}
        />
      }
      {
        sellVoucher && !codeVisible && <SellVoucher propertyId={propertyId}
          isvisible={sellVoucher} locale={locale}
          userData={userData}
          propertydata={propertydata}
          voucherList={voucherList}
          email={email}
          toggle={() => setSellVoucher(!sellVoucher)}
        />
      }
      {
        adsFrom && <AdsForm formLabel="Create a New Advertisement"
          visible={adsFrom}
          reportingTagData={reportingTagData}
          amadeus={amadeus}
          xolaIntegration={xolaIntegration}
          toggle={() => {
            setAdsForm(!adsFrom);
          }}
          submit={handleSubmit}
          inviteVoucher={inviteVoucher}
          ShowInviteVoucher={ShowInviteVoucher}
          propertyId={propertyId}
        />
      }
      {codeVisible && <GenerateCodes
        formLabel="Generate Codes"
        visible={false}
        toggle={() => {
          setCodeVisible(!codeVisible);
        }}
        update={false}
        LoadData={LoadData}
        amadeus={amadeus}
        xolaIntegration={xolaIntegration}
        id={voucherId}
        submit={handleSubmit}
        voucherName={voucherName}
        updateVoucherData={voucher}
        propertyId={propertyId}
      />}

      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(CreateVouchersForm));

// CreatePromosForm.propTypes = {
//   propertyId: PropTypes.string.isRequired,
// };
